import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { CallProvider } from "./context/CallContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Friends from "./pages/Friends";
import Flashcards from "./pages/Flashcards";
import VideoRoom from "./pages/VideoRoom";
import Admin from "./pages/Admin";
import Vision from "./pages/Vision";

function App() {
  return (
    <div className="App">
      <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <CallProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/friends" element={<ProtectedRoute><Friends /></ProtectedRoute>} />
            <Route path="/flashcards" element={<ProtectedRoute><Flashcards /></ProtectedRoute>} />
            <Route path="/room/:roomId" element={<ProtectedRoute><VideoRoom /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/moderation" element={<Navigate to="/admin" replace />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/donate" element={<Navigate to="/vision" replace />} />
          </Routes>
          </CallProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
